import { render, staticRenderFns } from "./ResourcesFigma.vue?vue&type=template&id=0732de15&scoped=true"
import script from "./ResourcesFigma.vue?vue&type=script&lang=js"
export * from "./ResourcesFigma.vue?vue&type=script&lang=js"
import style0 from "./ResourcesFigma.vue?vue&type=style&index=0&id=0732de15&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0732de15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0732de15')) {
      api.createRecord('0732de15', component.options)
    } else {
      api.reload('0732de15', component.options)
    }
    module.hot.accept("./ResourcesFigma.vue?vue&type=template&id=0732de15&scoped=true", function () {
      api.rerender('0732de15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Resources/ResourcesFigma.vue"
export default component.exports